module.exports = __webpack_public_path__ + "img/dragon-kart.be110228.png";